var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "inputWithLabel", class: { isPc: !_vm.isSp } },
      [
        _vm.hasLabel
          ? _c(
              "InputLabel",
              {
                staticClass: "labelArea",
                class: {
                  isPc: !_vm.isSp,
                  isHasLabel: !_vm.isSp && (_vm.required || _vm.optional),
                },
                attrs: {
                  required: _vm.required,
                  optional: _vm.optional,
                  "right-space": _vm.rightSpace,
                },
              },
              [_vm._v("\n      " + _vm._s(_vm.areaLabel) + "\n    ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "passwordWrapper" },
          [
            _c("InputItem", {
              staticClass: "inputItem",
              class: {
                hasError: _vm.hasError,
                isPc: !_vm.isSp,
                isLoginPage: _vm.isLoginPage,
              },
              attrs: {
                "input-type": _vm.inputType,
                "placeholder-value": _vm.placeholder,
                maxlength: _vm.maxlength,
              },
              on: { blur: _vm.onBlur },
              model: {
                value: _vm.handlePassword,
                callback: function ($$v) {
                  _vm.handlePassword = $$v
                },
                expression: "handlePassword",
              },
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "passwordMask",
                class: { isInvisible: _vm.isInvisible },
                on: { click: _vm.togglePassword },
              },
              [_c("img", { attrs: { src: "/images/contents/visible.svg" } })]
            ),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "underInputArea",
        class: {
          isPc: !_vm.isSp,
          isNoLabel: !_vm.isSp && !(_vm.required || _vm.optional),
        },
      },
      [
        _c("PartialErrorMessage", {
          staticClass: "partialErrorComponent",
          attrs: { "is-sp-flg": true, error: _vm.displayError },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }